import { styled } from '@styledComponents';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';

export const StyledSection = styled(Box)`
  height: 84vh;
  position: relative;
  z-index: 1;
  contain: strict;
  width: 100%;
  ${themeMediaQuery('sm')} {
    min-height: var(--hero-min-height);
  }
  ${themeMediaQuery('tablet')} {
    min-height: 680px;
    height: 50vh;
  }
`;

export const HeroVideoContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
`;

export const HeroVideoWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center center;
  overflow: hidden;
`;

export const HeroVideoOverlay = styled.span`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  background-color: #000;
  z-index: 3;
  opacity: 0.5;
`;

export const DisplayAboveMobile = styled(Box)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DisplayOnMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const HeroTextColumn = styled(Columns)`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 1;
  justify-content: center;
  display: flex;
  padding: 0;
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
`;

export const HeroTextPairing = styled(TextPairing)`
  margin-top: 0px;
  margin-bottom: ${themeSpace(11)};
  .text-pairing-title {
    max-width: 634px;
    font-size: 72px;
    line-height: 88px;
  }
  .text-pairing-eyebrow {
    width: 623px;
  }
  ${themeMediaQuery('below_sm')} {
    margin-bottom: initial;
    .text-pairing-eyebrow {
      text-align: center;
    }
    .text-pairing-title {
      text-align: center;
      font-size: 40px;
      line-height: normal;
      width: 285px;
    }
  }
  ${themeMediaQuery('tablet')} {
    .text-pairing-title {
      width: 285px;
    }
  }
`;
